import React, { useState } from "react";
import "./../styling/Calculator.css"
const BoundingBoxCalculator = () => {
  const [point, setPoint] = useState("");
  const [distance, setDistance] = useState("");
  const [boundingBox, setBoundingBox] = useState(null);

  const calculateBoundingBox = () => {
    const [lat, lon] = point.split(/[, ]+/).map(Number);
    const d = parseFloat(distance);

    if (isNaN(lat) || isNaN(lon) || isNaN(d)) {
      alert("Invalid input!");
      return;
    }

    const R = 6371; // Earth radius in km
    const dLat = d / R * (180 / Math.PI);
    const dLon = d / (R * Math.cos((lat * Math.PI) / 180)) * (180 / Math.PI);

    const bbox = {
      minLat: (lat - dLat).toFixed(6),
      maxLat: (lat + dLat).toFixed(6),
      minLon: (lon - dLon).toFixed(6),
      maxLon: (lon + dLon).toFixed(6),
    };

    setBoundingBox(bbox);
  };

  return (
    <div className="calculator-card">
      <h2>Bounding Box Calculator</h2>
      <input type="text" placeholder="Enter Point (lat, long)" value={point} onChange={(e) => setPoint(e.target.value)} />
      <input type="text" placeholder="Enter Distance (km)" value={distance} onChange={(e) => setDistance(e.target.value)} />
      <button onClick={calculateBoundingBox}>Calculate Bounding Box</button>
      {boundingBox && (
        <p>Bounding Box: <br /> 
          Min Lat: {boundingBox.minLat}, Max Lat: {boundingBox.maxLat} <br />
          Min Lon: {boundingBox.minLon}, Max Lon: {boundingBox.maxLon}
        </p>
      )}
    </div>
  );
};

export default BoundingBoxCalculator;